















import Vue from 'vue';
import LastFm from '@/api/LastFm';
export default Vue.extend({
  data() {
    return {
      checkingAuth: false,
    };
  },
  methods: {
    finishStep() {
      this.$emit('complete');
    },
  },
  async mounted() {
    this.$data.checkingAuth = true;
    const api = this.$store.state.lfmApi as LastFm;
    await api.init(this.$route.query);
    if (api.isAuthenticated()) {
      setTimeout(() => {
        this.$emit('complete');
      }, 2000);
    } else {
      this.$data.checkingAuth = false;
    }
  },
});
